import { useMemo } from "react";
import { UnreachableCaseError } from "../../../utils/errors/unreachable";
import { formatDate, fromISO8601_DATE } from "../../../utils/iso8601";

import type { FollowUpSchemaType } from "../reducer/schema";

export function useFollowUpScheduleText(
  schedule: FollowUpSchemaType["schedule"],
  moment: { title: string },
): string {
  return useMemo(() => {
    switch (schedule.type) {
      case "immediate":
        return "This Follow-Up will send as soon as you press “Publish”";
      case "specific":
        return `This Follow-Up will send on ${schedule.date ? formatDate(fromISO8601_DATE(schedule.date)) : ""} at ${schedule.time} (${schedule.timezone || "Recipient’s local time"})`;
      case "scheduled":
        return `Follow-Up will send ${schedule.amount} ${schedule.period} after "${moment.title}" at ${schedule.time} ${schedule.timezone || "Recipient’s local time"}. ${schedule.allow_weekends ? "" : " If that lands on a Saturday or Sunday, it will send on the following Monday."}`;
      default:
        throw new UnreachableCaseError(schedule);
    }
  }, [schedule, moment.title]);
}
